export default __webpack_public_path__ + "static/media/Warlord's Arrows.9a7faed4.jpg";